/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 */

import React from 'react';
import {
  StatusBar,
  useColorScheme,
} from 'react-native';

import Main from './src';
import {enableScreens} from 'react-native-screens';

import { NativeBaseProvider, Box } from "native-base";
import { useFonts } from 'expo-font';

function App(): JSX.Element {
  const [fontsLoaded, fontError] = useFonts({
    'Inter-Bold': require('./src/assets/fonts/Inter-Bold.88fa7ae373b07b41ecce.ttf'),
    'Inter-Light': require('./src/assets/fonts/Inter-Light.eec8664621fec98efb37.ttf'),
    'Inter-Medium': require('./src/assets/fonts/Inter-Medium.6dcbc9bed1ec438907ee.ttf'),
    'Inter-Regular': require('./src/assets/fonts/Inter-Regular.e89cb19905e7db5591b0.ttf'),
    'Poppins-Bold': require('./src/assets/fonts/Poppins-Bold.cdb29a5d7ccf57ff05a3.ttf'),
    'Poppins-Regular': require('./src/assets/fonts/Poppins-Regular.35d26b781dc5fda684cc.ttf'),
    'Poppins-Light': require('./src/assets/fonts/Poppins-Light.7641a0f76ca9ef6c252c.ttf'),
    'Poppins-Medium': require('./src/assets/fonts/Poppins-Medium.673ed42382ab264e0bf5.ttf'),
    'Poppins-SemiBold': require('./src/assets/fonts/Poppins-SemiBold.ac8d04b620e54be9b0f0.ttf'),
  });


  enableScreens();

  const isDarkMode = useColorScheme() === 'dark';
  

  return (
    <NativeBaseProvider>
      <StatusBar barStyle={isDarkMode ? 'light-content' : 'dark-content'} />
      <Main />      
    </NativeBaseProvider>
  );
}

export default App;
